<template>
    <v-card
            min-width="750"
            class="mt-2"
            elevation="0"
    >
        <div class="font-weight-black">STORE ON SALES CONFIG</div>
        <v-card
                class="pt-1 pb-1 ma-1"
                elevation="1">
            <v-subheader><strong>Gem Subscribe Daily Offers</strong></v-subheader>
            <v-row class="pl-5 pr-5">
                <v-col>
                    <v-label>
                        Total Gem Subscribe Days (per In-App)
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.totalGemSubscribeDays"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="1"
                            max="100"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.totalGemSubscribeDays"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="1"
                                    max="100"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
                <v-col>
                    <v-label>
                        Total Gem Subscribe Day Rewards (per In-App)
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.totalGemSubscribeDayRewards"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="1"
                            max="1000"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.totalGemSubscribeDayRewards"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="1"
                                    max="1000"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
            </v-row>

        </v-card>
        <v-card
                class="pt-1 pb-1 ma-1"
                elevation="1">
            <v-subheader><strong>Special Lucky Chest Daily Offers</strong></v-subheader>
            <v-row class="pl-5 pr-5">
                <v-col>
                    <v-label>
                        Special Lucky Chest Per Day
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.specialLuckyChestPerDay"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="1"
                            max="10"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.specialLuckyChestPerDay"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="1"
                                    max="10"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
                <v-col>
                    <v-label>
                        Special Lucky Chest Cost
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.specialLuckyChestCost"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="1"
                            max="100"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.specialLuckyChestCost"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="1"
                                    max="100"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
            </v-row>
        </v-card>
        <v-card
                class="pt-1 pb-1 ma-1"
                elevation="1">
            <v-subheader><strong>Special Deal</strong></v-subheader>
            <v-row class="pl-5 pr-5">
                <v-col>
                    <v-label>
                        Lucky Chest Cost
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.luckyChestCost"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="1"
                            max="100"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.luckyChestCost"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="1"
                                    max="100"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
                <v-col>
                    <v-label>
                        Epic Weapon
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.epicWeaponCost"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="1"
                            max="100"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.epicWeaponCost"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="1"
                                    max="100"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
            </v-row>
        </v-card>
        <v-card
                class="pt-1 pb-1 ma-1"
                elevation="1">
            <v-subheader><strong>Chest Reward Generator Config</strong></v-subheader>
            <v-row class="pl-5 pr-5">
                <v-col>
                    <v-label>
                        Randomize get Gold reward
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.chestRndGoldAppear"
                            @change="onChangedRndGoldAppearChange"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="0"
                            max="100"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.chestRndGoldAppear"
                                    @change="onChangedRndGoldAppearChange"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="0"
                                    max="100"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
                <v-col>
                    <v-label>
                        Randomize get Gem Reward
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.chestRndGemAppear"
                            @change="onChangedRndGemAppearChange"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="0"
                            max="100"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.chestRndGemAppear"
                                    @change="onChangedRndGemAppearChange"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="0"
                                    max="100"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
            </v-row>
            <v-row class="pl-5 pr-5">
                <v-col>
                    <v-label>
                        Min Randomize Gem to Gold Multiplier
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.chestGemGoldRewardMinExchange"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="1"
                            max="10"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.chestGemGoldRewardMinExchange"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="1"
                                    max="10"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
                <v-col>
                    <v-label>
                        Max Randomize Gem to Gold Multiplier
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.chestGemGoldRewardMaxExchange"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="1"
                            max="15"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.chestGemGoldRewardMaxExchange"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="1"
                                    max="15"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
            </v-row>
            <v-row class="pl-5 pr-5">
                <v-col>
                    <v-label>
                        Min Gem reward
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.chestGemPlusMinReward"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="1"
                            max="100"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.chestGemPlusMinReward"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="1"
                                    max="100"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
                <v-col>
                    <v-label>
                        Max Gem reward
                    </v-label>
                    <v-slider
                            v-model="storeOnSalesConfig.chestGemPlusMaxReward"
                            track-color="grey"
                            always-dirty
                            thumb-label
                            min="1"
                            max="100"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="storeOnSalesConfig.chestGemPlusMaxReward"
                                    class="mt-0 pt-0"
                                    type="number"
                                    min="1"
                                    max="100"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-col>
            </v-row>
        </v-card>
        <v-card-actions>
            <v-btn color="blue darken-1" text @click="didClose">Close</v-btn>
            <v-btn color="green darken-1" text @click="didSave">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import lodash from "lodash";

    export default {
        name: "UGSStoreOnSalesConfig",
        props: ["pStoreOnSalesConfig"],
        components: {
        },
        data() {
            return {
                messageAlert: '',
                storeOnSalesConfig: {},
            }
        },
        created() {
            this.storeOnSalesConfig = lodash.clone(this.pStoreOnSalesConfig);
        },
        methods:{
            didClose(){
                this.$emit('close');
            },
            didSave(){
                this.$store.commit(this.$store.state.commitActions.PUSH_STORE_ON_SALES_CONFIG, this.storeOnSalesConfig);
                this.$emit('save');
            },

            onChangedRndGoldAppearChange() {
                if (this.storeOnSalesConfig.chestRndGoldAppear > 100) {
                    this.storeOnSalesConfig.chestRndGoldAppear = 100;
                }
                this.storeOnSalesConfig.chestRndGemAppear = 100 - this.storeOnSalesConfig.chestRndGoldAppear;
            },
            onChangedRndGemAppearChange() {
                if (this.storeOnSalesConfig.chestRndGemAppear > 100) {
                    this.storeOnSalesConfig.chestRndGemAppear = 100;
                }
                this.storeOnSalesConfig.chestRndGoldAppear = 100 - this.storeOnSalesConfig.chestRndGemAppear;
            },
        },
    }
</script>

<style scoped>

</style>